import { render, staticRenderFns } from "./TagsSelectorList.vue?vue&type=template&id=1c19d55d&"
import script from "./TagsSelectorList.vue?vue&type=script&lang=js&"
export * from "./TagsSelectorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports